import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import useCountDown from "@pathwright/ui/src/components/hooks/useCountDown"
import PropTypes from "prop-types"

const StepStartLock = ({ step, nonPassiveStepStarts, onReload }) => {
  const stepStartsForceUpdate = useCountDown(step.starts, onReload)

  return (
    <BlankSlate
      body={<>This step unlocks {moment(nonPassiveStepStarts).fromNow()}</>}
    />
  )
}

StepStartLock.displayName = "StepStartLock"

StepStartLock.propTypes = {
  step: PropTypes.object.isRequired,
  onReload: PropTypes.func.isRequired
}

export default StepStartLock
